<template>
  <div class="wrapper">
    <div
      v-for="(imagePath, index) in allImages"
      :key="index"
      class="image-wrapper"
    >
      <lookbook-image
        :path="imagePath"
      />
    </div>
    <div class="clear" />
  </div>
</template>

<script>
import LookbookImage from '../components/LookbookImage.vue'

export default {
  name: 'About',
  components: { LookbookImage },
  data () {
    return {
      numberOfImages: 25,
      allImages: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const allRecords = []
      const numbersGot = []
      for (let i = 0; i < this.numberOfImages; i += 1) {
        let tmp = this.randomIntFromInterval(1, this.numberOfImages)
        while (numbersGot.includes(tmp)) {
          tmp = this.randomIntFromInterval(1, this.numberOfImages)
        }
        numbersGot.push(tmp)
        allRecords.push(this.getImagePath(tmp))
      }
      this.allImages = allRecords
    },
    randomIntFromInterval (min, max) { // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    getImagePath (number) {
      return require('../assets/lookbook/' + number + '.jpg')
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  height: 100%;
  width: 100%;
  padding-top: 60px;
}
.image-wrapper {
  position: relative;
    width: 100%;
    padding-bottom: calc(100% * 4/3);
    float: left;
    height: 0;
}

.clear {
  clear: left;
  width: 100%;
  height: 40px;
}

@media (min-width: 992px) {
  .wrapper {
    padding: 0;
  }
  .image-wrapper {
    position: relative;
    width: 33.3%;
    padding-bottom: calc(33.3% * 4/3);
    float: left;
    height: 0;
  }
}
</style>
